export default "__VITE_ASSET__8ed8ae03__"